
import Vue from "vue";
import { add, diff, multiply, sub, TimeRoster, TimeRosterGroup } from "./@types";
import DaysOfWeek from "./DaysOfWeek.vue";
import Period from "./Period.vue";

export default Vue.extend({
  components: {
    DaysOfWeek,
    Period,
  },
  props: {
    title: String,
    value: Array as () => TimeRoster,
    totalTime: String,
    readonly: Boolean,
  },
  inject: {
    form: { default: null },
  },
  data() {
    return {
      errorMessages: [],
      editValue: ([] as unknown) as TimeRoster,
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value: TimeRoster) {
        this.editValue = (value || []).map(v =>
          Object.assign({}, { days: v.days.map(d => d), periods: v.periods.map(p => ({ ...p })) })
        ) as TimeRoster;
        this.$emit("total", `${this.total[0].length == 1 ? '0' : ''}${this.total[0]}:${this.total[1].length == 1 ? '0' : ''}${this.total[1]}`)
      },
    },
  },
  computed: {
    // validation members
    shouldValidate(): boolean {
      return !this.readonly;
    },
    hasError(): boolean {
      return !!this.errorMessages.length;
    },
    total(): string[] {
      return this.value.reduce((sum, v) => add(sum, this.sum(v)), "00:00").split(":");
    },
  },
  methods: {
    sum(v: TimeRosterGroup): string {
      return multiply(
        v.periods.reduce((sum, v) => add(sum, sub(diff(v.from, v.to), v.breakTime || "00:00")), "00:00"),
        v.days.length
      );
    },
    validate(force?: boolean, value?: any): boolean {
      return this.hasError;
    },
    reset() {},
    resetValidation() {
      this.errorMessages = [];
    },
    onInput() {
      this.$emit("input", this.editValue);
    },
  },
});
